
import { clear, createStore, del, entries, get, set } from 'idb-keyval';
import { getProxyObject, getProxyTarget, toProxy, watchUpdates } from "../watcher";
import { INamespaceOptions, IStoreWithData } from "./store-intf";
import { Log } from "../log/Log";
import _ from 'lodash';
//   let db;
// const request = typeof window == 'undefined'?null:window.indexedDB.open("MyTestDatabase");
// if(request){
//   request.onerror = (event) => {
//     console.error("为什么不允许我的 web 应用使用 IndexedDB！");
//   };
//   request.onsuccess = (event) => {
//     console.log('idnexed db event', event)
//   };
// }

const libs:Record<string, IStoreWithData<Record<string, any>>> = {}

async function getNamespaceStoreWithData<T extends Record<string, any>>(ns:string, opts?:INamespaceOptions<T>):Promise<IStoreWithData<T>>{
    // let unsub:(()=>void)|undefined;
    const log = new Log(false, `indexedDb utils getNamespaceStoreWithData_${ns}`);
    log.pause = true
    // log.pause = ns !== 'devLibInfo'
    let ss = libs[ns];
    log.log('init indexed db', ns)
    if(ss){
        return ss as IStoreWithData<T>
    }
    const s = createStore(ns, ns)
    if(opts?.forceReset === true && opts.defData){
      console.log('clean s', ns)
      await clear(s);
      const keys = Object.keys(opts.defData)
      for (const key of keys) {
        console.log('clear insert', key, opts.defData[key])
        await set(key as IDBValidKey, opts.defData[key], s)
      }
      console.log('clean complete', ns);
    }
    const raw = await entries(s);
    let o:T|undefined
    if(raw && raw.length > 0){
      o = Object.fromEntries(raw);
    }
    if(!o){
      if(opts?.defData && opts.mergeDefData){
        o = opts.defData;
      }else{
        o = {} as T;
      }
    }
    await mergeDefault();
    async function mergeDefault(){
      log.log('mergeDefaultdata check opts', ns);
      if(!opts)return;
      log.log('mergeDefaultdata check mergeDefdata must is true', opts.mergeDefData);
      if(opts.mergeDefData !== true)return;
      log.log('start mergeDefaultdata', ns)
      if(!raw || raw.length == 0)return;
      log.log('mergeDefaultdata check defdata');
      if(!opts.defData)return;
      log.log('mergeDefaultdata check mergedefdata');
      if(opts.forceReset)return;
      log.log('mergeDefaultdata check o');
      if(!o)return;
      const defData = opts.defData
      log.log('real start mergeDefData', defData)
      let keys = Object.keys(defData);
      for(let i =0 ;i < keys.length; i ++){
        let key = keys[i];
        if(key in o)continue;
        log.log('add key', key, defData[key])
        await set(key, defData[key], s);
        (o as any)[key] = defData[key];
      }
      keys = Object.keys(o);
      for(let i = 0; i < keys.length; i ++){
        let key = keys[i];
        if(key in defData)continue;
        log.log('del key', key);
        await del(key, s);
        delete o[key];
      }
      log.log('after merge o=', o)
    }
    const data = toProxy(o);
    // 可能得设计微任务写入
    watchUpdates(data, async (info)=>{
      // log.forcePrint = true;
      log.log(` watchUpdates_fn ns=${ns} data=`,data)
      log.log(' watchUpdates_fn info=', info)
      if(info.watchChain.length == 0){
        // const pause = log.pause;
        // log.pause = false;
        console.error(' watchUpdates_fn no key found', info)
        console.error(' watchUpdates_fn no key found info=', info)
        console.error(' watchUpdates_fn data =', data)
        // log.pause = pause;
        return
      }
      const key = info.watchChain[0];
      if(!(key in data)){
        console.error(' watchUpdates_fn key not found in data', `key=${key}`, `ns=${ns}`)
        console.error(' watchUpdates_fn data =', data)
        return
      }
      log.log('watchUpdates_fn write', `key=${key}`, "v=", data[key])
      log.log('json value=', JSON.stringify(data[key]))
      try{
        // console.log('writeaab data=', data)
        let v = data[key];
        if(_.isObject(v)){
          v = getProxyTarget(v)
        }
        // console.log('writebba v', key, v)
        await set(key as IDBValidKey, v, s)
        // const x = await get(key, s)
        // console.log('write 3', x)
        log.log('getNamespaceStoreWithData_fn watchUpdates', info)
      }catch(e){
        console.trace('path')
        console.error('getNamespaceStoreWithData_fn watchUpdates set error', e)
      }
      // log.forcePrint = false;
    })
    async function clean(){
      const keys = Object.keys(data)
      for (const key of keys) {
        delete data[key]
      }
      await clear(s)
    }
    const res = {
      data,
      store:{
        getData:()=>data,
        read<U>(key:keyof T, defaultValue?:U):U|undefined{
          return data[key] ?? defaultValue;
        },
        write<K extends keyof T>(key: K, value: T[K], override?: boolean){
          data[key] = value;
          set(key as IDBValidKey, value, s)
        },
        clearAll():void{
          clean()
        },
        setAll(d:Partial<T>){
          clean();
          Object.assign(data, d)
          const keys = Object.keys(d)
          for (const key of keys) {
            set(key as IDBValidKey, d[key], s)
          }
        },
        remove(key:string):void{
          delete data[key]
          del(key as IDBValidKey, s)
        }
      }
    }
    

    libs[ns] = res;
    return res;
}
async function init(){

}
export const indexedDbUtils = {
    init,
    getIndexedDbStore:getNamespaceStoreWithData
}